'use strict';

var _ = require('../../dependency')._,
  $c = require('../../config'),
  $u = require('../../utilities');

exports.createConfig = createConfig;

function createConfig(ops) {

    var dataSeriesFields = null,
      modelFieldKeys = $u.charts.generateFieldKeysArray(ops.dataConfig),
      config = {
          chartId: ops.chartId,
          chartType: 'POINT_IN_TIME',
          dataSeries: ops.dataSeries,
          fieldNames: ops.fieldNames,
          filters: [$c.filters.INTERVAL, $c.filters.DATE],
          dataConfig: ops.dataConfig,
          dataSeriesFields: dataSeriesFields,
          modelFieldKeys: modelFieldKeys,
          additionalFilterConfig: {
            INTERVALS: ops.intervals 
          },
          tasks: [
              'durationFilter',
              'druidQueryGenerator',
              'druidQueryValidator',
              'fetchChartData',
              'druidResponseParser',
              {
                  name: 'findFilterIntervals',
                  config: {
                      intervals: ops.intervals,
                      dataKey: ops.dataKey
                  }
              },
              {
                  name: 'createDataPointsArray',
                  config: {
                      pointsResolution: ops.pointsResolution,
                      dataKey: ops.dataKey
                  }
              },
              {
                  name: 'partionedPointInTimeModifyResponse',
                  config: {
                      dataKey: ops.dataKey
                  }
              },
              {
                  name: 'updateChartModelData',
                  config: {
                      dataSeriesFields: dataSeriesFields,
                      modelFieldKeys: modelFieldKeys
                  }
              }
          ],
          chartTemplate: ops.chartTemplate,
          i18n: $c.graphs.CHART_METADATA[ops.chartId]
      };

    return config;
}